import { Validate } from "./validate";
import { displayGenericError, displayInputErrorMarkup, serviceNetworkError } from "./failhandler";

var contactform = (function () {
    "use strict";

    var main = $('#main'),
		contactform = $('.contactform'),
		submitBtn = null,
		messageDiv = null,
		errMessage = '';

    // Only add listeners on support page
    if (contactform.length > 0) {
        main.on('click', '.form input[type="submit"]', submitHandler);
        main.on('blur', '.form-item input', blurHandler);
    }

    //  Trigger chosen
    $('.chosen').chosen({ disable_search: true });

    // Submit handler
    function submitHandler(e) {
        e.preventDefault();
        var form = $(this).closest('.form'),
			serviceMethod = form.data('form-method'),
			inputs = form.find('.form-item-fixed input, .form-item-fixed textarea, .form-item-fixed select'),
            additionalinputs = form.find('.form-item-additional input'),
            selectedValue = form.find('select'),
			validated = true,
			request = {},
			data = {},
	        cl = new CanvasLoader('loaderContactform');
        
        submitBtn = form.find('input[type="submit"]');
        messageDiv = form.find('.form-message');
        errMessage = form.find('.form-message').data('error-message');               
        messageDiv.removeClass("alert-success").removeClass("alert-error").removeClass("error").hide();

        cl.setDiameter(20);
        cl.setDensity(17);
        cl.setRange(1.1);
        cl.setSpeed(1);
        cl.setColor('#ffffff');
        cl.setFPS(24);

        inputs.each(function () {
            if (!$(this).parent().hasClass('chzn-search')) {
                if (!Validate.validate.call($(this))) {
                    validated = false;
                }
            }
        });
        additionalinputs.each(function () {
            if (!$(this).parent().hasClass('chzn-search')) {
                if (!Validate.validate.call($(this))) {
                    validated = false;
                }
            }
        });

        if (validated) {
            
            submitBtn.addClass("loading");
            submitBtn.prop('disabled', true);
            cl.show();

            // Build data object
            inputs.each(function () {
                var $this = $(this),
					prop = $this.attr('name'),
					value = $this.val();
                request[prop] = value;
            });

            request.additionalfields = new Array();
            additionalinputs.each(function () {
                var $this = $(this),
					prop = $this.attr('name'),
					value = $this.val();
                request.additionalfields.push({Name: prop, Value:value });
            });
            request['contactformid'] = $("#hfFormID", form).val();
            request['pageid'] = SETTINGS.pageid;
            request['language'] = SETTINGS.language;

            data['request'] = request;

            var ajaxRequest = $.ajax({
                url: SETTINGS.services.forms.methods.contact,
                method: 'POST',
                data: JSON.stringify(data)
            });

            ajaxRequest.done(doneHandler);
            ajaxRequest.fail(failHandler);
        }

        function doneHandler(response) {            
            cl.hide();
            submitBtn.removeClass("loading");
            submitBtn.prop('disabled', false);
            
            if (response.Success) {
                inputs.each(function () { $(this).val(""); });
                messageDiv.addClass("alert-success");
                messageDiv.html(messageDiv.data('successMessage')).show();
                
            } else {
                messageDiv.addClass("alert-error").show();
                displayGenericError(messageDiv, response);
                displayInputErrorMarkup(form, response);
            }
        }

        function failHandler(jqXHR, textStatus, errorThrown) {
            cl.hide();
            submitBtn.removeClass("loading");
            submitBtn.prop('disabled', false);
            messageDiv.addClass("alert-error").show();
            serviceNetworkError(messageDiv);
        }
    }

    function blurHandler() {
        messageDiv = $(this).closest('.form').find('.form-message');
        Validate.validate.call($(this));
    }    
})();